
define('text!templates/infowindow.html',[],function () { return '<div class="c-infowindow__body">\r\n\t<img src="{{ImageUrl}}?width=300" class="c-infowindow__image" alt="" />\r\n\t<h3 class="c-infowindow__heading"><a href="{{Url}}" class="js-gtm-map-detail-click">{{Title}}</a></h3>\r\n\t<span class="c-infowindow__price">{{PriceSummary}}</span>\r\n</div>';});

